import type { WalkthroughDefinition } from "~/walkthroughs/types";

import { type MyLearningPathQuery } from "~/gql/queries/learning.generated";
import { getWalkthrough } from "~/walkthroughs/registry";

export type LearningPath = MyLearningPathQuery["myLearningPath"][number];

export type LearningConcept = LearningPath["concepts"][number];

const DOCS_ORIGIN = "https://docs.silverfern.com";

const docsUrl = (docsPath: string): string => {
	try {
		const url = new URL(docsPath, DOCS_ORIGIN);
		return url.origin === DOCS_ORIGIN ? url.toString() : DOCS_ORIGIN;
	} catch {
		return DOCS_ORIGIN;
	}
};

const isPathComplete = (path: LearningPath): boolean => path.completedCount >= path.totalCount;

const continueConceptId = (path: LearningPath): string | undefined => path.nextConceptId ?? path.concepts[0]?.conceptId;

const findPathForConcept = (paths: LearningPath[], conceptId: string): LearningPath | undefined =>
	paths.find((path) => path.concepts.some((concept) => concept.conceptId === conceptId));

const launchableTour = (walkthroughId: string | null | undefined): WalkthroughDefinition | undefined => {
	const definition = walkthroughId ? getWalkthrough(walkthroughId) : undefined;
	return definition && !definition.routePath.includes(":") ? definition : undefined;
};

const learningPaths = {
	continueConceptId,
	docsUrl,
	findPathForConcept,
	isPathComplete,
	launchableTour
};

export default learningPaths;
